var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "4px",
    viewBox: "0 0 7 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4DE1FF41-1405-4B90-A686-DC31EC27912F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TO-BE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Safety-Dashboard-Widgets",
    transform: "translate(-426.000000, -277.000000)",
    fill: "#808080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Headers",
    transform: "translate(64.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-Copy",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filters",
    transform: "translate(149.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(165.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "drop",
    transform: "translate(51.500000, 14.000000) scale(1, -1) translate(-51.500000, -14.000000) ",
    points: "51.5 12 55 16 48 16"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.82b0ae6639d0759633ffb470a49cfdd0.svg";
export { ForwardRef as ReactComponent };